module.exports = __webpack_public_path__ + "media/images/lp_v6_step03-24f723e12b18faa1aa957eadf2f17eca.webp";